import {Injectable} from "@angular/core";
import {TrackSelectPromotionDto} from "@app/core/tracking/domain/dtos/track-select-promotion.dto";
import {TrackingService} from "@app/core/tracking/domain/repositories/tracking.service";

@Injectable({
    providedIn: 'root',
})
export class TrackSelectPromotionUseCase {
    constructor(
        private trackingService:TrackingService,
    ) {}

    execute(dto: TrackSelectPromotionDto) {
        this.trackingService.selectPromotion(dto)
    }
}
